export default __webpack_public_path__ + "static/media/cart.c1d9ab9e.svg";